import React, { useMemo } from "react";
import "./Product_overview.css";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import parse from "html-react-parser";

function Product_overview({
  product,
  selectedVariant,
  activeMetal,
  activeSize,
  activeTriple,
}) {
  const hasContent = (html) => {
    if (!html) return false;
    const cleaned = html
      .replace(/<[^>]+>/g, "") // remove HTML tags
      .replace(/&nbsp;/g, "") // remove non-breaking spaces
      .trim();
    return cleaned.length > 0;
  };

  // ✅ Show tab only if status is true AND content is valid
  // const tabs = useMemo(() => {
  //   return [
  //     {
  //       key: "overview",
  //       status: product?.description_status,
  //       label: "Overview",
  //       content: product?.description,
  //     },
  //     {
  //       key: "composition",
  //       status: product?.composition_status,
  //       label: "Composition",
  //       content: product?.composition,
  //     },
  //     {
  //       key: "advantages",
  //       status: product?.advantages_status,
  //       label: "Advantages",
  //       content: product?.advantages,
  //     },
  //     {
  //       key: "preservation",
  //       status: product?.preservation_status,
  //       label: "Preservation",
  //       content: product?.preservation,
  //     },
  //   ]
  //     .filter((t) => t.status === true && hasContent(t.content)); // ✅ only show if status true AND has content
  // }, [product]);

  const tabs = useMemo(() => {
    const plating = activeMetal?.name || "";
    const colour = activeSize?.name || "";
    const size = activeTriple?.name || "";

    const occassion =
      activeTriple?.occassion ||
      activeSize?.occassion ||
      activeMetal?.occassion ||
      "";

    const designShape =
      activeTriple?.design_shape ||
      activeSize?.design_shape ||
      activeMetal?.design_shape ||
      "";

    const variant = activeMetal;
    const tabData = [
      {
        key: "description",
        label: "Description",
        content: product?.description,
      },

      {
        key: "overview",
        label: "Overview",
        content: activeMetal?.product_description,
      },

      {
        key: "details",
        label: "Product Details",
        content: activeMetal?.product_details,
      },

      {
        key: "base_metal",
        label: "Base Metal",
        content: activeMetal?.base_metal,
      },

      {
        key: "stone",
        label: "Stone",
        content: activeMetal?.stone,
      },

      {
        key: "weight",
        label: "Product Weight(gms)",
        content: activeMetal?.product_weight,
      },

      {
        key: "length",
        label: "Product Length(cms)",
        content: activeMetal?.product_length,
      },

      {
        key: "earring_weight",
        label: "Earring Weight (gms)",
        content: activeMetal?.earring_weight,
      },

      {
        key: "earring_style",
        label: "Earring Style",
        content: activeMetal?.earring_style,
      },

      {
        key: "earring_closer",
        label: "Earring Closer Type",
        content: activeMetal?.earring_closer_type,
      },

      {
        key: "necklace_style",
        label: "Necklace Style",
        content: activeMetal?.neckalace_style,
      },

      {
        key: "unit",
        label: "Unit",
        content: activeMetal?.unit,
      },

      // {
      //   key: "brand",
      //   label: "Brand",
      //   content: product?.Brand?.name,
      // },

      {
        key: "plating",
        label: "Polish",
        content: plating,
      },

      {
        key: "colour",
        label: "Colour",
        content: colour,
      },

      {
        key: "size",
        label: "Size",
        content: size,
      },

      {
        key: "occasion",
        label: "Occasion",
        content: occassion,
      },

      {
        key: "design_shape",
        label: "Design Shape",
        content: designShape,
      },

      {
        key: "hsn",
        label: "HSN",
        content: product?.item_code,
      },
    ];

    return tabData.filter((t) => {
      if (!t.content) return false;

      const value = String(t.content).trim();

      return (
        value !== "" &&
        value !== "N/A" &&
        value !== "null" &&
        value !== "undefined"
      );
    });
  }, [product, activeMetal, activeSize, activeTriple, selectedVariant]);

  const defaultActiveKey = tabs.length > 0 ? tabs[0].key : null;
 

  return (
    <section className="Product_overview ">
      <div className="container-fluid">
        {tabs.length > 0 ? (
          <>
            {/* <div className="Product_overview_tabs">
            <Tab.Container id="product-tabs" defaultActiveKey={defaultActiveKey}>
              <Row>
                <Col sm={12}>
                  <Nav variant="pills" className="flex tabs_holder">
                    {tabs.map((tab) => (
                      <Nav.Item key={tab.key}>
                        <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Col>

                <Col sm={12}>
                  <Tab.Content className="tab_content_holder">
                    {tabs.map((tab) => (
                      <Tab.Pane key={tab.key} eventKey={tab.key}>
                        <p>{tab.content}</p>
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
            </div> */}

            <div className="product_details_wrapper">
              <div className="product_overview_inner_div">
                <p className="title_p">Overview</p>
                <div className="product_details_table">
                  {tabs.map((tab, index) => (
                    <div className="product_details_row" key={tab.key}>
                      <div className="product_details_label">
                        <p className="label_text">{tab.label}</p>
                      </div>

                      <div className="product_details_value">
                        <p className="value_text">{tab.content}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : (
          <p
            className="text-center"
            style={{
              color: "white",
              fontWeight: "500",
              marginTop: "20px",
            }}
          >
            No product details available
          </p>
        )}
      </div>
    </section>
  );
}

export default Product_overview;
